import script from "./ConfirmDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmDialog.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmDialog.vue?vue&type=style&index=0&id=3f3c0ea0&lang=scss"

const __exports__ = script;

export default __exports__